import { gql } from '@apollo/client'
import { mapPointsClient } from '../../../../../utils/apollo/api'
import { formatApiDate } from '../../../../../utils/helpers/date'
import { usePromiseQuery } from '../../../../../utils/apollo/_helpers/promiseQuery'
import { pathOr } from 'ramda'
import { useMapActions } from '../../../../../components/map/MapContext'
const QUERY = gql`
  query MapPoints($filter: MapPointHistoryFilter) {
    mapPointsHistory(filter: $filter) {
      latitude
      longitude
      happenedAt
    }
  }
`

export const useMapPointsHistoryLoader = form => {
  const { setRoute } = useMapActions()
  const query = usePromiseQuery(QUERY, { client: mapPointsClient })
  return () => {
    const now = new Date()
    const newDate = new Date(now.getTime() - form.pastHours * 60 * 60 * 1000)

    const formattedFilter = {
      mapPointId: form.user.id,
      endDate: formatApiDate(now),
      startDate: formatApiDate(newDate)
    }
    return query({ filter: formattedFilter })?.then(result => {
      setRoute(pathOr([], ['data', 'mapPointsHistory'])(result))
    })
  }
}
